export const PAYROLL_QUERY_KEYS = {
  ONBOARD_COMPANY: 'payrollOnboardCompany',
  PAY_SCHEDULE: 'payrollPaySchedule',
  SETUP_EMPLOYEE: 'payrollSetupEmployee',
  RUN_PAYROLL: 'runPayroll',
  TAX_LIABILITIES: 'payrollTaxLiabilities',
  W4CSV: 'payrollW4CSV',
  W2CSV: 'payrollW2CSV',
  CASH_REQUIREMENT_REPORT: 'payrollCashRequirementReport',
  CONTRACTOR_PAYMENTS: 'payrollContractorPayments',
  APPLIED_FOR_TAX_PARAMETERS: 'payrollAppliedForTaxParameters',
  CONTRACTORS_PAYMENT_LIST: 'payrollContractorsPaymentList',
  SETUP_PAYROLL: 'setupPayroll',
  ONBOARDING_STEPS: 'payrollOnboardingSteps',
  PAYROLL_STATUS: 'payrollStatus',
  PAYROLL_HISTORY: 'payrollHistory',
  PAYROLL_HISTORY_CVS: 'payrollHistoryCSV',
  LAST_PAYROLL_DETAILS: 'lastPayrollDetails',
  PAYROLL_EMPLOYEES: 'payrollEmployees',
  PAYROLL_EMPLOYEE_PAYSTUBS: 'payrollEmployeePaystubs',
  PAYROLL_EMPLOYEE_ONBOARDING_LINK: 'payrollEmployeeOnboardingLink',
  WORKPLACES: 'payrollWorkplaces',
  WORKPLACE: 'payrollWorkplace',
  PAPER_CHECKS: 'paperChecks',
  PAY_SCHEDULES: 'payrollPaySchedules',
  AUTHENTICATED_SELF_ONBOARDING_LINK: 'payrollAuthenticatedSelfOnboardingLink',
  TOKEN_BASED_SELF_ONBOARDING_LINK: 'payrollTokenBasedSelfOnboardingLink',
  ADMIN_ORG_SETTINGS: 'payrollAdminOrgSettings',
  ORG_SETTINGS: 'payrollOrgSettings',
  LICENSE_SELECTION: 'payrollLicenseSelection',
  UNBLOCK_PRO_FACING_ONBOARDING: 'payrollUnblockProFacingOnboarding',
  FINALIZE_ONBOARDING: 'payrollFinalizeOnboarding',
  ADMIN_ADD_EMPLOYEE: 'payrollAdminAddEmployee',
  NON_PAYROLL_EMPLOYEES: 'nonPayrollEmployees',
  CREATE_PAYROLL_EMPLOYEE: 'payrollCreatePayrollEmployee',
  EMPLOYEE_DETAILS: 'payrollEmployeeDetails',
  GET_PAYROLL_EMPLOYEE: 'getPayrollEmployee',
  UPDATE_PAYROLL_EMPLOYEE: 'updatePayrollEmployee',
};
